import * as THREE from 'three';
import { getWorldTransform, get } from '../modules/scene';
import { getCamera } from '../modules/player';
import getProjectionMatrix from './utils/getProjectionMatrix';

function getScreenPositionNormal(nodeWorldMatrix, cameraWorldMatrix,
    cameraProjection, localDirection) {

  const cameraInverseWorldMatrix = new THREE.Matrix4().getInverse(cameraWorldMatrix);

  const combinedCameraSpaceMatrix = new THREE.Matrix4().multiply(cameraInverseWorldMatrix).multiply(nodeWorldMatrix);
  const combinedProjectionMatrix = new THREE.Matrix4().multiply(cameraProjection).multiply(cameraInverseWorldMatrix).multiply(nodeWorldMatrix);

  const nodeLocalPosition = new THREE.Vector3(0, 0, 0);
  const nodeLocalDirectionOffset = localDirection;

  const nodeCameraPosition = nodeLocalPosition.clone()
      .applyMatrix4(combinedCameraSpaceMatrix);
  const nodeCameraDirectionOffset = nodeLocalDirectionOffset.clone()
      .applyMatrix4(combinedCameraSpaceMatrix);

  const nodeCameraNormal = new THREE.Vector3()
      .subVectors(nodeCameraDirectionOffset, nodeCameraPosition).normalize();

  const nodeScreenPosition = nodeLocalPosition.clone()
      .applyMatrix4(combinedProjectionMatrix);
  nodeScreenPosition.addScalar(1.0).multiplyScalar(0.5);

  return {
    position: nodeScreenPosition,
    normal: nodeCameraNormal,
  };
}

export function getScreenPositionNormalAlpha(id, calcDirection, directionAxis, directionTarget) {
  return (store) => {
    const nodeWorldTransform = getWorldTransform(store, id);
    const cameraId = getCamera(store);
    const cameraPlug = get(store, { id: cameraId, evalPlug: 'Camera' });

    const cameraWorldTransform = getWorldTransform(store, cameraId);
    if (!cameraWorldTransform) return {};

    const cameraProjection = getProjectionMatrix(cameraPlug);
    const positionNormal = getScreenPositionNormal(nodeWorldTransform,
        cameraWorldTransform, cameraProjection, getDirection(store, id, calcDirection, directionAxis, directionTarget));

    const annotation = get(store, { id, evalPlug: 'Annotation' });

    let alpha = 1.0;

    // mis-spelled visibility property.
    if (annotation.limitVisilibility) {
      const visibilityAngle = Math.min(annotation.visibilityAngle * 0.5, 180);
      const cameraWorldDirection = new THREE.Vector3(0, 0, -1);
      const dotResult = cameraWorldDirection.dot(positionNormal.normal);
    
      const theta = THREE.Math.radToDeg(
        Math.acos(cameraWorldDirection.dot(positionNormal.normal))
      );
 
      if (theta > visibilityAngle) {
        alpha = 0.0;
      } else if (theta > visibilityAngle * 0.75) {
        alpha = (visibilityAngle - theta) / (visibilityAngle * 0.25); 
      }
    }

    return Object.assign({ alpha }, positionNormal);
  };
}

function getDirection(store, id, calcDirection, directionAxis, directionTarget) {
  var direction = null;
  if( calcDirection ) {
    let targetPosition = new THREE.Vector3(0, 0, 0);
    if (directionTarget) {
      targetPosition = new THREE.Vector3().setFromMatrixPosition(getWorldTransform(store, directionTarget));
    }
    const currentTransform = getWorldTransform(store, id);
    const currentPosition = new THREE.Vector3().setFromMatrixPosition(currentTransform);
    direction = targetPosition.clone().sub(currentPosition).normalize();
    const inverseWorldMatrix = new THREE.Matrix4();
    inverseWorldMatrix.getInverse(currentTransform);
    direction.applyMatrix4(inverseWorldMatrix).normalize();
  }
  else {
    direction = new THREE.Vector3();
    direction[ directionAxis ] = -1;
  }

  return direction;
}



// WEBPACK FOOTER //
// ./src/translators/annotation.js